import React from 'react';
import {connect} from 'react-redux';
import MPMRegistrationsWidget from './Widgets/Registrations';
import MPMUsersByMatchesWidget from './Widgets/UsersByMatches';
import MPMNumbersOfPlayersWidget from './Widgets/NumbersOfPlayers';
import MPMPlatformsWidget from './Widgets/Platforms';

const MPMStats = props => (
  <div id="statistics">
    <header className="content-header">
      <h1>
        Statistics
        <small> MPM</small>
      </h1>
    </header>
    <section className="content">
      <MPMRegistrationsWidget />
    </section>
    <section className="content">
      <div className="row">
        <div className="col-md-6">
          <MPMUsersByMatchesWidget />
        </div>
        <div className="col-md-6">
          <MPMNumbersOfPlayersWidget />
          <MPMPlatformsWidget />
        </div>
      </div>
    </section>
  </div>
);

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(MPMStats);



// WEBPACK FOOTER //
// ./src/pages/Other/MPM/Stats/index.tsx